import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateEntityRightsForUserMutation } from "org/user/queries/useUpdateEntityRightsForUserMutation";
import { UserOrUserGroupOverview } from "utils/user";

import { EntityRow } from "./useUserEntitiesListTable";

interface UseReplaceEntityUserUtilsProps {
    userId: number;
    selectedRows: Row<EntityRow>[];
    deselectAll: () => void;
}

export function useReplaceEntityUserUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseReplaceEntityUserUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutate, isPending, error, reset } =
        useUpdateEntityRightsForUserMutation();

    const replaceUserToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const replaceUser = (userOrGroup: UserOrUserGroupOverview) => {
        const entityIds = selectedRows.map((row) => row.original.id);
        mutate(
            { userId, data: { newUserId: userOrGroup.id, entityIds } },
            {
                onSuccess: () => {
                    deselectAll();
                    setIsModalOpen(false);
                },
                // On failure the modal stays open; `error` drives the notice.
            }
        );
    };

    return {
        replaceUserToolState,
        isReplaceUserModalOpen: isModalOpen,
        replaceUserError: error,
        // Reset on open (not close) so the notice stays put during the close
        // animation and a stale error can't reappear next time.
        openReplaceUserModal: () => {
            reset();
            setIsModalOpen(true);
        },
        closeReplaceUserModal: () => setIsModalOpen(false),
        replaceUser,
        isReplacingUser: isPending,
    };
}
